'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { SearchContainer } from '@cat-ecom/pcc-components';
import { CatInputField } from 'blocks-nextjs/blocks-react/components/InputField';
import { BlocksChangeEvent } from 'blocks-nextjs/blocks-web-components/events';
import { useFormContext } from 'react-hook-form';

export const FilterByOrderAndPONumberFields = ({
  isQuoteEnabled
}: {
  isQuoteEnabled: boolean;
}) => {
  const t = useTranslations();
  const { setValue, watch } = useFormContext();
  const currentOrderReferenceNumber = watch('filterByOrderOrReferenceNumber');
  const currentPONumber = watch('filterByPONumber');
  const hasPOCharacterError = watch('hasPOCharacterError');
  const hasOrderNumInputError = watch('hasOrderOrReferenceNumberFieldError');

  const orderOrReferenceTitle = isQuoteEnabled
    ? t('ORDER_REFERENCE_OR_QUOTE_NUMBER')
    : t('ORDER_NUMBER_REFERENCE_NUMBER');

  const orderOrReferenceLabel = isQuoteEnabled
    ? t('ENTER_ORDER_REFERENCE_QUOTE_NUMBER')
    : t('ENTER_ORDER_REFERENCE_NUMBER');

  const handleOrderOrReferenceChange = (e: BlocksChangeEvent) => {
    const orderNumInput = e.detail.value;
    if (orderNumInput.length >= 3) {
      setValue('hasOrderOrReferenceNumberFieldError', false);
    } else {
      setValue('hasOrderOrReferenceNumberFieldError', true);
    }
    setValue('filterByOrderOrReferenceNumber', orderNumInput);
  };

  const handlePONumberChange = (e: BlocksChangeEvent) => {
    const poNumInput = e.detail.value.trim();
    const hasProhibitedCharacter =
      poNumInput.includes('>') || poNumInput.includes('<');

    if (hasProhibitedCharacter && !hasPOCharacterError) {
      setValue('hasPOCharacterError', true);
    } else if (!hasProhibitedCharacter && hasPOCharacterError) {
      setValue('hasPOCharacterError', false);
    }
    setValue('filterByPONumber', poNumInput);
  };

  return (
    <SearchContainer title={t('SEARCH_CATALOG')} customClassName="mx-3 py-3">
      <div className="my-2">
        <CatInputField
          className="pb-4"
          name="orderOrReference"
          value={currentOrderReferenceNumber}
          ariaDescribedBy="orderOrReference"
          aria-label={orderOrReferenceTitle}
          fieldId="orderOrReference"
          data-testid="orderOrReference"
          label={orderOrReferenceTitle}
          onBlChange={handleOrderOrReferenceChange}
          placeholder={orderOrReferenceLabel}
          type="text"
          status={hasOrderNumInputError ? 'error' : undefined}
          errorNote={hasOrderNumInputError ? t('MEQ_ADD_EQ_ERROR1') : undefined}
        />
        <CatInputField
          name="poNumber"
          value={currentPONumber}
          ariaDescribedBy="poNumber"
          aria-label={t('CAT_CORE_TRACK_PO_NUM')}
          fieldId="poNumber"
          data-testid="poNumber"
          label={t('CAT_CORE_TRACK_PO_NUM')}
          onBlChange={handlePONumberChange}
          placeholder={t('ENTER_PO_NUMBER')}
          maxlength={20}
          type="text"
          errorNote={hasPOCharacterError ? t('PO_PROHIBITED_CHAR') : undefined}
          status={hasPOCharacterError ? 'error' : undefined}
          hideWordCount
        />
      </div>
    </SearchContainer>
  );
};
